import { baseServiceRequest } from "@apis/baseServiceRequest"
import type {
  ICaseChannel,
  ICaseSearch,
  ICaseSearchParams,
  ICaseStatus,
  ICaseStatusChangeReason,
  ICaseType,
} from "./types"
import type {} from "@commonTypes/searchParams"

export const editCaseNote = async ({
  case_guid,
  request,
}: {
  case_guid: string
  request: {
    note_id: number
    new_note: string
  }
}) => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/cases/${case_guid}/edit_note`,
    data: request,
  })
  return response.data
}

export const getCases = async ({
  params,
  signal,
}: {
  params: ICaseSearchParams
  signal: AbortSignal
}): Promise<ICaseSearch> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "/cases/list",
    params: {
      ...params,
      filterObj: JSON.stringify(params.filterObj),
    },
    signal,
  })
  return response.data
}

export const getCaseTypes = async (): Promise<ICaseType[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "/cases/types",
  })
  return response.data
}

export const getCaseChannels = async (): Promise<ICaseChannel[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "/cases/channels",
  })
  return response.data
}

export const getCaseStatuses = async (): Promise<ICaseStatus[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "/cases/case_statuses",
  })
  return response.data
}

export const getCaseStatusChangeReasons = async (): Promise<
  ICaseStatusChangeReason[]
> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "/cases/case_status_change_reasons",
  })
  return response.data
}
